import { inventoryTotal } from "@/components/VideoInventory";

const tags = (it) => [it.is_fragile && "Fragile", it.is_heavy && "Heavy", it.disassembly_required && "Disassemble", it.notes].filter(Boolean).join(", ");

export function PrintableInventory({ rooms }) {
  const total = inventoryTotal(rooms);
  const count = rooms.reduce((s, r) => s + r.items.reduce((a, it) => a + it.quantity, 0), 0);
  return (
    <div className="hidden print:block text-black text-[12px]" data-testid="printable-inventory">
      <div className="flex items-center justify-between border-b-2 border-black pb-3 mb-4">
        <div className="flex items-center gap-3">
          <img src="/logo-mark.png" alt="" className="h-12 w-12" />
          <div><p className="text-xl font-black tracking-tight">MOVETENDER</p><p className="text-[11px] font-bold uppercase">Moving inventory</p></div>
        </div>
        <div className="text-right text-[11px]">
          <p>{new Date().toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" })}</p>
          <p className="font-bold">{count} items · {total} m³ (incl. 15% packing allowance)</p>
        </div>
      </div>
      {rooms.map((r) => (
        <table key={r.room_name} className="w-full mb-4 border-collapse break-inside-avoid">
          <thead>
            <tr><th colSpan={4} className="text-left text-sm font-bold bg-gray-100 px-2 py-1 border border-gray-300">{r.room_name}</th></tr>
            <tr className="text-left text-[11px]">
              <th className="border border-gray-300 px-2 py-1 w-[44%]">Item</th><th className="border border-gray-300 px-2 py-1 w-[10%]">Qty</th>
              <th className="border border-gray-300 px-2 py-1">Notes</th><th className="border border-gray-300 px-2 py-1 w-[12%] text-right">m³</th>
            </tr>
          </thead>
          <tbody>
            {r.items.map((it, i) => (
              <tr key={i}>
                <td className="border border-gray-300 px-2 py-1">{it.item_name}{it.description ? <span className="block text-[10px] text-gray-600">{it.description}</span> : null}</td>
                <td className="border border-gray-300 px-2 py-1">{it.quantity}</td>
                <td className="border border-gray-300 px-2 py-1">{tags(it)}</td>
                <td className="border border-gray-300 px-2 py-1 text-right">{(it.quantity * it.unit_m3).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}
      <p className="mt-6 text-[11px] border-t border-gray-300 pt-2">Get free quotes for this move: post it on MoveTender and verified removalists compete for your job. Free for customers.</p>
    </div>
  );
}
